module.exports = __webpack_public_path__ + "media/images/common/bird-5795e8525b38a892a120532dc2fc04b1.png";